import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { CoachformComponent } from './components/Coach/account/coachform/coachform.component';
import { ListCoachComponent } from './components/admin/coach/list-coach/list-coach.component';
import { LoginComponent } from './components/shared/login/login.component';
import { AdminHomeComponent } from './components/admin/home/admin-home.component';
import { ClientHomeComponent } from './components/client/home/client-home.component';
import { CoachHomeComponent } from './components/Coach/home/coach-home.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { ListPackageComponent } from './components/admin/package/list-package/list-package.component';
import { ReportComponent } from './components/shared/report/report.component';

import { AuthGuardAdmin } from './helpers/AuthGuardAdmin';
import { AuthGuardUser } from './helpers/AuthGuardUser';
import { AuthGuardCoach } from './helpers/AuthGuardCoach';
import { FormInscriptionComponent } from './components/shared/form-inscription/form-inscription.component';
import { UserFormComponent } from './components/Coach/client/user-form/user-form.component';
import { ForgotPasswordComponent } from './components/shared/forgot-password/forgot-password.component';
import { MentionsComponent } from './components/Coach/account/mentions/mentions.component';
import { PolitiqueComponent } from './components/Coach/account/politique/politique.component';
import { CgvComponent } from './components/Coach/account/cgv/cgv.component';
import { CguComponent } from './components/Coach/account/cgu/cgu.component';
import { ContactComponent } from './components/Coach/account/contact/contact.component';
import { ObjectivePageComponent } from './components/Coach/client/objective-client/objective-page/objective-page.component';
import { PaymentsListComponent } from './components/Coach/bills/payments-list/payments-list.component';
import { AccountComponent } from './components/Coach/account/account.component';
import { SubscribeComponent } from './components/Coach/account/subscribe/subscribe.component';
import { InformationComponent } from './components/Coach/account/information/information.component';
import { DashboardFinanceComponent } from './components/Coach/dashboards/dashboard-finance/dashboard-finance.component';
import { ListDayComponent } from './components/Coach/sessions/list-day/list-day.component';
import { PageClientComponent } from './components/Coach/client/page-client/page-client.component';
import { DashboardComponent } from './components/Coach/dashboards/dashboard/dashboard.component';
import { ListFormuleComponent } from './components/Coach/formules/list-formule/list-formule.component';
import { ListAddressComponent } from './components/Coach/address/list-address/list-address.component';
import { ListSessionBisComponent } from './components/Coach/sessions/list-session-bis/list-session-bis.component';
import { ListSessionComponent } from './components/Coach/sessions/list-session/list-session.component';
import { ListUserComponent } from './components/Coach/client/list-user/list-user.component';
import { SiteComponent } from './components/site/site.component';
import { AboutComponent } from './components/Coach/account/about/about.component';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'admin',
    component: AdminHomeComponent,
    canActivate: [AuthGuardAdmin],
    children: [
      {
        path: 'coachList',
        component: ListCoachComponent,
      },
      {
        path: 'packages',
        component: ListPackageComponent,
      },
      {
        path: 'reportBug',
        component: ReportComponent
      },
    ]
  },
  {
    path: 'client',
    component: ClientHomeComponent,
    canActivate: [AuthGuardUser],
    children: [
      {
        path: 'userList',
        component: ListUserComponent,
      }
    ]
  },
  {
    path: 'website',
    component: SiteComponent,
  },
  {
    path: 'coach',
    component: CoachHomeComponent,
    canActivate: [AuthGuardCoach],
    children: [
      {
        path: 'userList',
        component: ListUserComponent,
      },
      {
        path: 'sessionList',
        component: ListSessionComponent
      },
      {
        path: 'sessionListBis',
        component: ListSessionBisComponent
      },
      {
        path: 'addressList',
        component: ListAddressComponent
      },
      {
        path: 'formuleList',
        component: ListFormuleComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'client',
        component: PageClientComponent,
      },
      {
        path: 'sessionDay',
        component: ListDayComponent,
      },
      {
        path: 'dashboard-finance',
        component: DashboardFinanceComponent,
      },
      {
        path: 'information',
        component: InformationComponent,
      },
      {
        path: 'subscribe',
        component: SubscribeComponent,
      },
      {
        path: 'account',
        component: AccountComponent,
      },
      {
        path: 'payments-list',
        component: PaymentsListComponent,
      },
      {
        path: 'objective-page',
        component: ObjectivePageComponent,
      },
      {
        path: 'reportBug',
        component: ReportComponent
      },
      {
        path: 'contact',
        component: ContactComponent
      },
      {
        path: 'cgu',
        component: CguComponent
      },
      {
        path: 'cgv',
        component: CgvComponent
      },
      {
        path: 'politique',
        component: PolitiqueComponent
      },
      {
        path: 'mentions',
        component: MentionsComponent
      },
      {
        path: 'about',
        component: AboutComponent
      },
    ]
  },
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'Coachform',
    component: CoachformComponent
  },
  {
    path: 'listCoach',
    component: ListCoachComponent
  },
  {
    path: 'Inscription',
    component: FormInscriptionComponent
  },
  {
    path: 'userForm',
    component: UserFormComponent
  },
  {
    path: 'forgotPassword',
    component: ForgotPasswordComponent
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
